import { render, staticRenderFns } from "./FullScreenButton.vue?vue&type=template&id=ecaf1f56"
import script from "./FullScreenButton.vue?vue&type=script&lang=js"
export * from "./FullScreenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports